import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { Trash2, Minus, Plus, ShoppingBag } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { formatPrice } from "../mock";
import { PageTitle } from "../components/Shared";

const CartPage = () => {
  const { t, lang, cart, updateQty, removeFromCart, cartTotal } = useShop();
  const { lp } = useLocale();

  if (cart.length === 0) {
    return (
      <div data-testid="cart-page">
        <PageTitle title={t("cart")} />
        <div className="idm-container idm-empty-cart">
          <ShoppingBag size={48} strokeWidth={1.2} />
          <p data-testid="empty-cart-message">{t("emptyCart")}</p>
          <Link to={lp("/shop")} className="idm-btn-yellow" data-testid="return-to-shop">
            {t("returnToShop")}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="cart-page">
      <PageTitle title={t("cart")} />
      <div className="idm-container idm-cart-layout">
        <div className="idm-cart-table-wrap">
          <table className="idm-cart-table" data-testid="cart-table">
            <thead>
              <tr>
                <th>{t("product")}</th>
                <th>{t("price")}</th>
                <th>{t("quantity")}</th>
                <th>{t("subtotal")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cart.map((item) => (
                <tr key={item.id} data-testid={`cart-row-${item.slug}`}>
                  <td className="idm-cart-product">
                    <img src={item.image} alt={item.name[lang]} />
                    <Link to={lp(`/product/${item.slug}`, item.slug_en)}>{item.name[lang]}</Link>
                  </td>
                  <td>{formatPrice(item.price)}</td>
                  <td>
                    <div className="idm-qty idm-qty-sm">
                      <button onClick={() => updateQty(item.id, item.qty - 1)} aria-label="Decrease" data-testid={`cart-minus-${item.slug}`}>
                        <Minus size={12} />
                      </button>
                      <span>{item.qty}</span>
                      <button onClick={() => updateQty(item.id, item.qty + 1)} aria-label="Increase" data-testid={`cart-plus-${item.slug}`}>
                        <Plus size={12} />
                      </button>
                    </div>
                  </td>
                  <td className="idm-cart-subtotal">{formatPrice(item.price * item.qty)}</td>
                  <td>
                    <button
                      className="idm-remove-btn"
                      onClick={() => removeFromCart(item.id)}
                      aria-label={t("remove")}
                      data-testid={`cart-remove-${item.slug}`}
                    >
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="idm-cart-totals" data-testid="cart-totals">
          <h3>{t("cartTotals")}</h3>
          <div className="idm-totals-row">
            <span>{t("subtotal")}</span>
            <span>{formatPrice(cartTotal)}</span>
          </div>
          <div className="idm-totals-row idm-totals-total">
            <span>{t("total")}</span>
            <span data-testid="cart-total-value">{formatPrice(cartTotal)}</span>
          </div>
          <p className="idm-vat-note">{t("vatIncluded")}</p>
          <Link to={lp("/checkout")} className="idm-btn-yellow idm-btn-block" data-testid="proceed-checkout">
            {t("proceedToCheckout")}
          </Link>
          <Link to={lp("/shop")} className="idm-continue-link">
            {t("continueShopping")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
